import { createRoot } from 'react-dom/client'
import { App } from './App'

document.addEventListener('DOMContentLoaded', function () {
	const container = document.getElementById('app-mapa-dana-valencia')
	const lang = document.documentElement.lang || 'ca'
	const preview = new URLSearchParams(window.location.search).get('preview') === '1'
	const root = createRoot(container)
	root.render(<App lang={lang} preview={preview} embedHome={false} />)
})
